var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5312 12.5L17.4062 16.375C17.5 16.4688 17.5 16.625 17.4062 16.75L16.7188 17.4375C16.5938 17.5312 16.4375 17.5312 16.3438 17.4375L15.6875 16.7812L12.5 13.5625L8.625 17.4375C8.53125 17.5312 8.375 17.5312 8.25 17.4375L7.5625 16.75C7.46875 16.625 7.46875 16.4688 7.5625 16.375L11.4375 12.5L7.5625 8.65625C7.46875 8.5625 7.46875 8.40625 7.5625 8.28125L8.25 7.59375C8.375 7.5 8.53125 7.5 8.625 7.59375L12.5 11.4688L16.3438 7.59375C16.4375 7.5 16.5938 7.5 16.7188 7.59375L17.4062 8.28125C17.5 8.40625 17.5 8.5625 17.4062 8.65625L16.75 9.3125L13.5312 12.5Z",
    fill: "#00095B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.192c76da9b995fc755cc71ba920420f1.svg";
export { ForwardRef as ReactComponent };